export default {
    reviewOrder: {
        reviewOrder: "Bestelling bekijken"
    }
}